<finder-anchor #cardElement
    *ngIf="searchResult.url; else cardContent"
    class="active-link"
    [href]="searchResult.url"
    (click)="sendSearchSelection()"
    [target]="searchTarget"
>
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
</finder-anchor>


<ng-template #cardContent>
    <div #cardElement [ngSwitch]="searchResult.type">
        <div class="search-card plan-disney" *ngSwitchCase="planDisney">
            <div class="card-content">
                <div class="content">
                    <div class="header plan-header">
                        <finder-picture *ngIf="planDetail.logo" [picture]="planDetail.logo" class="fit"></finder-picture>
                        <finder-anchor *ngIf="planDetail.seeMore.urlTemplate" class="see-more" [href]="planDetail.seeMore.urlTemplate">
                            {{ planDetail.seeMore.label }}
                        </finder-anchor>
                    </div>
                    <div class="qa-section">
                        <div class="qa-column qa-icon">
                            <finder-font-icon [name]="planDetail.questionLogo" size="m" class="search-icon"></finder-font-icon>
                        </div>
                        <div class="qa-column">
                            <div class="qa-title">{{planDetail.questionTitleTemplate}}</div>
                            <div class="qa-detail">{{planDetail.questionDetail}}</div>
                        </div>
                    </div>

                    <div class="qa-section">
                        <div class="qa-column qa-icon">
                            <finder-font-icon [name]="planDetail.answerLogo" size="m" class="search-icon">
                            </finder-font-icon>
                        </div>
                        <div class="qa-column">
                            <div class="qa-title">{{planDetail.answerTitleTemplate}}</div>
                            <div class="qa-detail">
                                {{ planDetail.answerDetail | truncateText: 0 : planDetail.maxTextSize }}
                                <finder-anchor *ngIf="planDetail.url" [href]="planDetail.url">
                                    <span class="qa-link">{{ planDetail.label }}</span>
                                </finder-anchor>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="arrow-icon" [ngClass]="{'hide-arrow-icon': !searchResult.url}">
                    <finder-font-icon name="next-2" class="search-icon"></finder-font-icon>
                </div>
            </div>
        </div>

        <div class="search-card disney-blog" *ngSwitchCase="disneyParkBlog">
            <div class="card-content">
                <div class="content">
                    <div class="header blog-header">
                        <div class="blogLogoContainer ">
                            <finder-picture *ngIf="blogpostDetail.logo" [picture]="blogpostDetail.logo" class="fit"></finder-picture>
                        </div>
                        <h3 class="card-title card-title-blog" [innerHTML]="blogpostDetail.title | safeHtml"></h3>
                    </div>
                    <p class="description blog-detail"> {{ blogpostDetail.postDetailTemplate }}</p>
                    <p class="description blog-detail"> {{ blogpostDetail.postContent | truncateText: 0 : blogpostDetail.maxTextSize }}</p>
                    <finder-anchor *ngIf="blogpostDetail.url" class="blog-link" [href]="blogpostDetail.url">
                        {{ blogpostDetail.label }}
                    </finder-anchor>
                    <finder-anchor *ngIf="blogpostDetail.blogLink.url" class="blog-link" [href]="blogpostDetail.blogLink.url">
                        {{ blogpostDetail.blogLink.label }}
                    </finder-anchor>
                </div>
                <div class="arrow-icon" [ngClass]="{'hide-arrow-icon': !searchResult.url}">
                    <finder-font-icon name="next-2" class="search-icon"></finder-font-icon>
                </div>
            </div>
        </div>

        <div class="search-card faq-disney" *ngSwitchCase="faqDisney">
            <div class="card-content">
                <div class="content">
                    <div class="card-title-container">
                        <finder-font-icon class="icon card-icon search-icon card-title" [name]="faqDetail.icon" *ngIf="faqDetail.icon"></finder-font-icon>
                        <h2 class="card-title" [innerHTML]="faqDetail.title"></h2>
                    </div>
                    <div class="qa-section faq-question">
                        <div class="qa-column qa-icon">
                            <finder-font-icon [name]="faqDetail.questionLogo" size="m" class="search-icon"></finder-font-icon>
                        </div>
                        <div class="qa-column">
                            <p class="qa-title" [innerHTML]="faqDetail.faqQuestion | safeHtml"></p>
                        </div>
                    </div>

                    <div class="qa-section">
                        <div class="qa-column qa-icon">
                            <finder-font-icon [name]="faqDetail.answerLogo" size="m" class="search-icon">
                            </finder-font-icon>
                        </div>
                        <div class="qa-column">
                            <div class="qa-detail" [innerHTML]="faqDetail.faqAnswer | truncateText: 0 : faqDetail.maxTextSize | safeHtml">
                            </div>
                            <finder-anchor [href]="searchResult.url" *ngIf="searchResult.url">
                                <span class="qa-link">{{ faqDetail.seeMore }}</span>
                            </finder-anchor>
                        </div>
                    </div>
                </div>
                <div class="arrow-icon" [ngClass]="{'hide-arrow-icon': !searchResult.url}">
                    <finder-font-icon name="next-2" class="search-icon"></finder-font-icon>
                </div>
            </div>
        </div>

        <div class="search-card resort-attraction" *ngSwitchDefault>
            <div class="card-content">
                <div class="content">
                    <div class="picture" *ngIf="picture">
                        <finder-picture [picture]="picture" class="fit"></finder-picture>
                    </div>
                    <div class="card-information">
                        <div class="card-title-container">
                            <finder-font-icon class="icon card-icon search-icon card-title" [name]="searchResult.icon" *ngIf="searchResult.icon"></finder-font-icon>
                            <h2 class="card-title" [innerHTML]="searchResult.title"></h2>
                            <ng-content select="[titleContent]"></ng-content>
                        </div>
                        <finder-anchor *ngIf="parkType" [href]="parkType.url">
                            <span class="park-link">{{ parkType.name }}</span>
                        </finder-anchor>
                        <span *ngIf="searchResult.land" class="land">{{ searchResult.land }}</span>
                        <span *ngIf="searchResult.experiences" class="land">{{ searchResult.experiences }}</span>
                        <span *ngIf="shipLocations" class="land">
                            <finder-anchor class="ship-location" *ngFor="let location of shipLocations" [href]="location.url">
                                {{ location.name }}
                            </finder-anchor>
                        </span>
                        <div class="description-container" [ngClass]="{'no-description': !searchResult.description}">
                            <p class="description"
                                [ngClass]="{'description-text-schedules': searchResult.serviceStyle}"
                                *ngIf="searchResult.description"
                                [innerHTML]="searchResult.description | safeHtml"></p>
                            <div class="schedule-container" *ngIf="searchResult.serviceStyle">
                                <p class="schedule-service-title">{{searchResult.serviceStyle}}</p>
                                <div class="schedule-service-time" *ngIf="searchResult.schedule">
                                    <p>{{searchResult.schedule}}</p>
                                </div>
                            </div>
                        </div>
                        <finder-operating-status
                            [labels]="searchResult.labels"
                            [data]="searchResult"
                            [facilityId]="searchResult.id">
                        </finder-operating-status>
                        <finder-premier-access class="search" *ngIf="searchResult.disneyPremierAccess" [card]="searchResult"></finder-premier-access>
                        <finder-anchor class="park-link" *ngIf="searchResult.portUrl && searchResult.portName" [href]="searchResult.portUrl">
                            {{ searchResult.portName }}
                        </finder-anchor>
                    </div>
                </div>
                <div class="arrow-icon" [ngClass]="{'hide-arrow-icon': !searchResult.url}">
                    <finder-font-icon name="next-2" class="search-icon" [title]="searchResult.title">
                    </finder-font-icon>
                </div>
            </div>
        </div>
    </div>
</ng-template>
